export { PersonaTooltip, PersonaTooltipProps } from './PersonaTooltip';
